<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<div class="header-container">
			<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>	
		</div>
		<!-- <Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/> -->
		<div class="content">
			<div style="height:60px;"></div>
			<div class="news-container">
				<button
					v-if="showBackButton"
					type="button"
					class="news-detail-back"
					@click="goBackToSource"
				>
					‹ {{ $t('newIndex.sections.news.backToSection') }}
				</button>
				<section class="news-wrapper">
					<div class="news-left">
						<span class="text-style">{{$t('news.news')}}</span>
					</div>
					<div class="news-right">
						<div class="news-item">
							<div class="news_title">
								<span v-html="newsDetail.title"></span>
								<div class="news_title_item">
									<span>{{newsDetail.updated_at}}</span>
									<span style="margin-left:20px;" v-if="newsDetail.source">{{$t('news.source')}}{{newsDetail.source}}</span>
									<span style="margin-left:20px;">{{$t('contentViews')}} {{views}}</span>
								</div>

								<!-- <span>{{$t('news.publish_time')}}{{newsDetail.updated_at}}</span> -->
							</div>
							<div class="news_content">
								<div class="html-content" v-html="newsDetail.content" style="text-align: justify;"></div>
							</div>
							
						</div>						
					</div>
				</section>
			</div>

		</div>
		<Footer/>
	</div>
</template>

<script>
	import news_detail from './news_detail_controller';
	export default news_detail;
</script>
<style>
	@font-face {
	    font-family: 'SimKai';
	    src: url('/font/simkai.ttf'),
	         url('/font/STKAITI.TTF');
	    font-display: swap;
	}

	  /* 映射汉字字体名 */
	@font-face {
	    font-family: '楷体';
	    src: local('STKaiti'), 
	         local('KaiTi'),
	         local('SimKai'),
	         local('BiauKai'),
	         url('/font/simkai.ttf'),
	         url('/font/STKAITI.TTF');
	    font-display: swap;
	}
</style>
<style src="@/assets/css/news_detail.css" scoped></style>

<style>
/*.news_content .html-content p span{
	text-align: center;
}
.news_content .html-content p img{
	width:auto!important;
	max-width:800px!important;
	object-fit: contain;
}
@media screen and (max-width: 767px) {
	.news_content .html-content p img{
		width:auto!important;
		max-width:100%!important;
		height:auto!important;
	}
}*/
</style>